import { useQuery } from "@tanstack/react-query";
import { fetchSubtemplates, FetchSubtemplatesParams } from "PFCore/services/subtemplates";
import { Subtemplate } from "PFTypes";
import { QueryOptions } from "PFTypes/request_options";

export const useSubtemplates = <TData = Subtemplate[]>(
  params: FetchSubtemplatesParams,
  options: QueryOptions<Subtemplate[], unknown, TData> = {}
) =>
  useQuery<Subtemplate[], unknown, TData>({
    queryKey: ["subtemplates", params],
    queryFn: () => fetchSubtemplates(params),
    retry: false,
    ...options
  });
